export const INVALID_TOKEN_CODE = 'USR_JWT_00002';
export const INVALID_FORMAT_TOKEN = 'USR_JWT_00001';
export const INVALID_TOKEN = 'USR_JWT_00003';
export const TERMS_NOT_ACCEPTED = 'USR_REG_00004';
export const INVALID_PASSWORD = 'USR_PSW_00012';
